window.addEventListener( 'load', function() {

	function toggleTextItem( button ) {
		const textContent = document.getElementById( button.getAttribute( 'aria-controls' ) );
		if ( textContent ) {
            const parent = button.closest( '.content-toggle' );
			parent.classList.toggle( 'content-toggle--displayed' );
            button.setAttribute( 'aria-expanded', parent.classList.contains( 'content-toggle--displayed' ) );
		}
	}

	const textItemsButtons = document.querySelectorAll( '.content-toggle__button' );
	[...textItemsButtons].forEach( textItemButton => {
		textItemButton.addEventListener( 'click', e => {
			toggleTextItem( textItemButton );
		} );
	} );

} );